import React from "react";
import * as CONSTANT from "../../constants";
import styleClasses from "./career.module.scss";
import { Col, Row } from "react-bootstrap";
import FreeItem from "../../components/Home/subComponents/FreeItem";
import OurBenefits from "./OurBenefits";
import TeamIntro from "./TeamIntro";
import CareerNav from "./careerNav";
import { REACT_APP_CLOUD_FRONT } from "../../constants";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import BottomMenu from "../home/BottomMenu";
import { useIsDesignV2 } from "../../hooks/useIsDesignV2";

const teamJobsArray = [
  {
    image: `images/culinary-team/culinaryImg1.png`,
    content:
      "Follow recipes to make soups, dressings, and sandwich spreads from scratch.",
  },
  {
    image: `images/culinary-team/culinaryImg2.png`,
    content: "Wash and prepare deliveries of produce for House-Made Happiness.",
  },
  {
    image: `images/culinary-team/culinaryImg3.png`,
    content: "Make sure the kitchen is prepped, stocked and ready to go.",
  },
];

const Culinary = () => {
    const isItMobile = useCheckMobileScreen();
    const isDesignV2 = useIsDesignV2();
    return(
    <>
      <div className={`${styleClasses.positionsWrapper} ${isDesignV2 && styleClasses.positionsWrapper_mobile_designv2}`}>
        <Row>
          <Col lg="6" md="6" sm="12" xs="12" className={"px-0"}>
            <div className={`h-100 ${styleClasses.positionHeroImg}`}>
              <img
                src={`${REACT_APP_CLOUD_FRONT}/images/culinary-team/culinaryBanner.png`}
                alt="culinaryBanner"
                className="w-100"
              />
            </div>
          </Col>
          <Col lg="6" md="6" sm="12" xs="12" className={`px-0`}>
            <div
              className={`d-flex flex-column justify-content-center align-item-center h-100 py-5 px-4 py-md-5 px-md-5 my-md-0 text-center text-md-start ${styleClasses.culinaryContent} ${styleClasses.hospitalityContent}`}>
              <h1
                className={`clr-dark-grey f-s50 f-w4 text-capitalize mb-0 mb-md-4 pb-3 f-sm-s32 f-md-s40 w-100 lh-normal`}>
                culinary <br className="d-none d-md-block" /> team
              </h1>
              <p
                className={`${styleClasses.positionHeroDescription} f-s20 f-w4 clr-dark-grey f-sm-s16 font-Trade-regular mb-2 mb-md-5 p-0`}>
                Get a taste of The Good Life and get hands-on experience working
                with real food with a career in a Café Zupas Kitchen.
              </p>
              <div className="text-center text-md-start w-100 mt-3 mt-md-0">
                <a
                  href={CONSTANT.CAREERS_APPLY_ROUTE_URL}
                  target="blank"
                  className={`${styleClasses.careerBtns} text-decoration-none color-white f-s20 f-w7 font-Visby-cf text-uppercase btn btn-large f-sm-s14`}>
                  apply now
                </a>
              </div>
            </div>
          </Col>
        </Row>
        <div className={`container ${styleClasses.dayInLifeSec}`}>
          <h1
            className={
              "lh-normal ls-normal text-uppercase clr-green-clr font-Visby-cf f-s55 f-w7 f-sm-s24 pb-md-3 mb-0 mb-md-5 pb-0"
            }>
            working with real food
          </h1>
          <div className={`${styleClasses.teamJobs} pt-0`}>
            <div className={styleClasses.customeRow}>
              <Row className="justify-content-center">
                {teamJobsArray.map((item, i) => {
                  return (
                    <Col md={4} lg={3} className="mb-5 mb-md-0">
                      <div key={i} className={`${styleClasses.customeCol} cursor-default`}>
                        <div>
                          <img
                            src={`${REACT_APP_CLOUD_FRONT}/${item.image}`}
                            className={`img-fluid ${styleClasses.imgss}`}
                            alt={"img"}
                          />
                          <p
                            className={`${styleClasses.desc} ${styleClasses.positionHover} f-w4 clr-dark-grey font-Trade-regular mb-0 f-s16 text-capitalize mt-4 px-4`}>
                            {item.content}
                          </p>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </div>
        </div>
        <TeamIntro
          title={<>Are we a good fit?</>}
          description={
            <>
              <p className="mb-0 pb-0 font-Trade-regular f-sm-s16 text-start text-md-center">
                No experience is necessary—we will train the right person!{" "}
                <br /> If you check these boxes, we’ll get along great:
              </p>
              <ul>
                <li className="font-Trade-regular f-s20 font-Trade-regular f-sm-s16">
                  {" "}
                  <span></span>✔️ Punctual and reliable
                </li>
                <li className="font-Trade-regular f-s20 font-Trade-regular f-sm-s16">
                  {" "}
                  <span></span>✔️ Enjoys working with people
                </li>
                <li className="font-Trade-regular f-s20 font-Trade-regular f-sm-s16">
                  {" "}
                  <span></span>✔️ Friendly & service-oriented
                </li>
                <li className="font-Trade-regular f-s20 font-Trade-regular f-sm-s16">
                  {" "}
                  <span></span>✔️ Excellent communication skills
                </li>
                <li className="font-Trade-regular f-s20 font-Trade-regular f-sm-s16">
                  {" "}
                  <span></span>✔️ Good at prioritizing
                </li>
              </ul>
            </>
          }
          btnText={"apply now"}
          className={styleClasses.hospitality}
          isVideo={false}
          isReversed={false}
          imgUrl={`images/culinary-team/culinaryFit.png`}
          videoUrl={undefined}
          borderBottom={""}
          sectionClasses={styleClasses.hospitalitySec}
        />
        <OurBenefits
            heading={"perks of the good life"}
            description={false}
            className={styleClasses.culinaryPage} isShowTeamTips={true}        />
        <FreeItem
          headingText="ready to join our team?"
          isButtonShow={true}
          isDescriptionShow={true}
          buttonText={"explore careers"}
          btnRoute={CONSTANT.CAREERS_APPLY_ROUTE_URL}
        />
        {isDesignV2 && <BottomMenu/>}
      </div>
    </>
  );
};

export default Culinary;
